<script>
export default {
    name: "VMenuContext",
    data() {
        return {
            isShow: false,
            item: null,
            x: null,
            y: null,
        };
    },
    methods: {
        show(event, {item}) {
            this.isShow = true;
            this.item = item;
            this.x = event.x;
            this.y = event.y;
        },
    },
}
</script>

<template>
    <v-menu
        v-model="isShow"
        :position-x="x"
        :position-y="y"
        ref="contextMenu"
    >
        <v-list>
            <slot v-bind="{item}"></slot>
        </v-list>
    </v-menu>
</template>

<style scoped lang="scss">

</style>
